import { render } from "./ExternalServices.vue?vue&type=template&id=8d4b94ec&scoped=true&ts=true"
import script from "./ExternalServices.vue?vue&type=script&lang=ts"
export * from "./ExternalServices.vue?vue&type=script&lang=ts"

import "./ExternalServices.vue?vue&type=style&index=0&id=8d4b94ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4b94ec"]])

export default __exports__